/* eslint-disable class-methods-use-this */
import OneSignal from 'react-onesignal';

/*
  Deleting users cannot be reversed!
  Once you delete users, there is no way to get them back. Deleted users can only get push again once they:
  Web: Clear browser cookies, then return to your site
*/

class OneSignalHandler {
  constructor() {
    this.isInit = false;
    this.userId = null;
    this.token = null;
    this.optedIn = false;

    this.companyId = null;
    this.onSubscriptionUpdate = null;
    this.onInit = null;

    this.audio = new Audio('/system-notification.mp3');
    this.audio.volume = 0.5;
    this.audioPlayerInterval = null;

    this.allowPlayNotification = localStorage.getItem('web-push-play-notifications') === 'true';
  }

  async init() {
    if (this.isInit) {
      return;
    }

    this.isInit = true;

    try {
      await OneSignal.init({
        appId: '75ab7206-d8a4-4fa9-bae9-d3daba2ac8c8',
        allowLocalhostAsSecureOrigin: true,
        notifyButton: { enable: false },
        promptOptions: {
          customLink: {
            enabled: true,
            actionMessage: 'Enable web push notifications to receive updates on certain processes',
            acceptButtonText: 'Enable',
            cancelButtonText: 'Cancel',
          },
        },
        safari_web_id: 'web.onesignal.auto.4e6ae055-7872-4c1f-b42a-6c60bed16bbe',
        welcomeNotification: {
          title: 'Subscribed',
          message: 'You will now receive push notifications with selected updates',
        },
      });
    } catch (e) {
      console.log('Web Push Init Error', e);
    }

    this.userId = OneSignal.User.PushSubscription.id;
    this.token = OneSignal.User.PushSubscription.token;
    this.optedIn = OneSignal.User.PushSubscription.optedIn;

    if (this.onInit) {
      this.onInit();
    }

    OneSignal.User.PushSubscription.addEventListener('change', (state) => {
      console.log('Web Push Subscription Change:', state.previous, state.current);

      if (state.current) {
        this.userId = state.current.id;
        this.token = state.current.token;
        this.optedIn = state.current.optedIn;
      }

      if (this.onSubscriptionUpdate) {
        this.onSubscriptionUpdate();
      }
    });

    // to launch test: start ngrok, add ngrok url to onesignal, use this url on phone then.

    OneSignal.Notifications.addEventListener('foregroundWillDisplay', (event) => {
      console.log('Web Push Received:', event);

      if (this.allowPlayNotification) {
        this.audio
          .play()
          .then(() => this.haveInteracted())
          .catch(() => this.requireInteraction());

        // seems like topics are md5 hashed
        if (
          event &&
          event.notification &&
          (event.notification.topic === 'ORDER_PLACED' ||
            event.notification.topic === '7c0eaef7aba601ad0525b480cb1cc75b')
        ) {
          this.showNotificationBanner('New order received');

          clearInterval(this.audioPlayerInterval);

          this.audioPlayerInterval = setInterval(() => {
            this.audio
              .play()
              .then(() => this.haveInteracted())
              .catch(() => this.requireInteraction());
          }, 10000);
        }
      }
    });
  }

  isSubscribed() {
    return !!this.userId && this.optedIn;
  }

  subscribe() {
    if (this.userId) {
      OneSignal.User.PushSubscription.optIn();
    } else {
      OneSignal.Slidedown.promptPush({ force: true });
    }
  }

  // To play audio in background, need user to click on something first
  requireInteraction() {
    this.showNotificationBanner(
      'New notification received. Press confirm to enable sound for next notifications.',
    );
  }

  // When user clicks on something, audio can play
  haveInteracted() {}

  // shows banner that new order received
  showNotificationBanner(text) {
    document.getElementById('order-alert-banner-text').textContent = text;
    document.getElementById('order-alert-banner').classList.remove('hidden');
  }

  // closes banner for new order and stops playing audio
  clearNotificationBanner() {
    document.getElementById('order-alert-banner').classList.add('hidden');

    clearInterval(this.audioPlayerInterval);
  }

  // Not using this
  unsubscribe() {
    if (this.userId) {
      OneSignal.User.PushSubscription.optOut();
    }
  }
}

export const pushHandlerSingleton = { handler: null };

export const initOneSignal = () => {
  if (pushHandlerSingleton.handler) {
    return;
  }

  pushHandlerSingleton.handler = new OneSignalHandler();
  pushHandlerSingleton.handler.init();
};
